import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { UsersService } from 'src/app/users/users.service';
import { MultiTariffService } from '../multi-tariff.service';
import { DeleteProfileResponse, Profile, ProfileSite, ReplaceProfileResponse } from '../multi-tariff.model';

@Component({
	selector: 'app-multi-tariff-profiles-list',
	templateUrl: './profiles-list.component.html',
	styleUrls: ['./profiles-list.component.css']
})
export class ProfilesListComponent implements OnInit, AfterViewInit {

	@ViewChild('deleteConfirmModal') deleteConfirmModal: ModalComponent;
	@ViewChild('replaceProfileModal') replaceProfileModal: ModalComponent;
	@ViewChild('profileSitesModal') profileSitesModal: ModalComponent;

	profiles: Profile[] = [];
	profileToDelete: Profile = null;
	profilesToReplaceWith: Profile[] = [];
	newProfileId: number = null;
	profileSites: ProfileSite[] = [];

	hasWriteAccess = false;

	constructor(
		private router: Router,
		private usersService: UsersService,
		private notificationMessage: NotificationMessageService,
		private translateService: TranslateService,
		public multiTariffService: MultiTariffService
	) { }

	ngOnInit() {
		if (!this.usersService.hasAccessFunction('global_multi_tariff_profiles'))
			return this.router.navigate(['/unauthorized']);

		this.hasWriteAccess = this.usersService.hasAccessFunction('global_multi_tariff_profiles', 'write');
		this.getProfiles();

		return;
	}

	getProfiles() {
		this.multiTariffService.getAllProfiles().subscribe((profiles: Profile[]) => {
			this.profiles = profiles || [];
		});
	}

	confirmDelete(profile: Profile) {
		this.profileToDelete = profile;
		this.deleteConfirmModal.show();
	}

	deleteProfile() {
		if (!this.profileToDelete)
			return;

		this.multiTariffService.deleteProfile(this.profileToDelete.id).subscribe((res: DeleteProfileResponse) => {
			if (res && res.deleted === false) {
				this.notificationMessage.setMessage(
					this.translateService.instant('multi_tariff.profile.delete_used_profile_msg'),
					{ clearOnXTimeNavigate: 1 }
				);
				return;
			}

			this.notificationMessage.setMessage('globalSuccessMsg', { clearOnXTimeNavigate: 1 });
			this.getProfiles();
		});
	}

	showReplaceOptions() {
		this.newProfileId = null;
		this.profilesToReplaceWith = [
			{ id: null, name: this.translateService.instant('multi_tariff.no_profile') },
			...this.profiles.filter((profile) => profile.id !== this.profileToDelete.id)
		];

		this.replaceProfileModal.show();
	}

	replaceProfile() {
		if (!this.profileToDelete)
			return;

		this.multiTariffService.replaceProfile(this.newProfileId, this.profileToDelete.id).subscribe((res: ReplaceProfileResponse) => {
			if (res && res.replaced === false) {
				this.notificationMessage.setMessage(
					this.translateService.instant('multi_tariff.profile.not_used'),
					{ clearOnXTimeNavigate: 1 }
				);
				this.getProfiles();
				return;
			}

			this.notificationMessage.setMessage('globalSuccessMsg', { clearOnXTimeNavigate: 1 });
			this.getProfiles();
		});
	}

	showProfileSites(profile: Profile) {
		this.multiTariffService.getProfileSites(profile.id).subscribe((sites: ProfileSite[]) => {
			this.profileSites = sites || [];
			this.profileSitesModal.show();
		});
	}

	ngAfterViewInit() {
		this.deleteConfirmModal.onClose.subscribe((confirmed: boolean) => {
			if (confirmed)
				this.deleteProfile();
		});

		this.replaceProfileModal.onClose.subscribe((confirmed: boolean) => {
			if (confirmed)
				this.replaceProfile();
		});
	}
}
